
import { BaseModel } from '../abstracts/base.model'

export class VirtualClassModel extends BaseModel {
    VirtualClassID: string
    VirtualClassName: string
    VirtualClassRoomName: string
    ClassID: string
    LessonID: string
    InstructorID: string
    StartDate: Date
    EndDate: Date
    DueDate: Date
    Duration: number
    ProviderID: number
    ProviderUrl: string
    LessonEndDate: Date
    StatusID: number

    TrainingName:string
    InstructorFirstName:string
    InstructorLastName:string
    ClassName:string
    CompanyName:string
    StudentID: number
    StudentName: string
}